import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[ax-dialog]',
    standalone: true,
})
export class DialogDirective {
    constructor(public readonly viewRef: ViewContainerRef) {}
}
